import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { APIListResponse } from "@shared/api-client-services/api-responses.interface";
import { map } from "rxjs";
import { Company, CompanyProductTypeEquipmentCheckConfiguration } from "./rentals-company-base.client.interface";
import { environment } from "@environments/environment";

@Injectable({ providedIn: 'root' })
export class RentalsCompanyBaseClient {
    private http = inject(HttpClient);

    getCompanyById(companyId: number) {
        const url = `${environment.rentalsApiEndPoint}/base/company/${companyId}`;

        return this.http.get<Company>(url);
    }

    getCompanyProductTypeEquipmentCheckConfigurations(productTypeId: number, active: boolean = true) {
        const url = `${environment.rentalsApiEndPoint}/base/company-product-type-equipment-check-configuration/`;
        const params = { productTypeId, active };
        const options = { params };

        return this.http.get<APIListResponse<CompanyProductTypeEquipmentCheckConfiguration>>(url, options).pipe(map(response => response.items));
    }
}